import React from "react";
import ATitle from "../components/ATitle";
import GradientButton from "../components/GradientButton";
import { daoVoiting } from "../placeholder";

export default function () {
  return (
    <div className="dao dao_enerm">
      <ATitle text="DAO Voting" />
      <div className="dao-content">
        <ul className="dao-list">
          {daoVoiting.map((item) => (
            <li className="dao-item block-view" key={item.id}>
              <div className="dao-item__left">
                <h5 className="dao-item__title item-title item-title_18">
                  {item.title}
                </h5>
                <p className="dao-item__text item-text">{item.text}</p>
              </div>
              <div className="dao-item__right">
                <div className="item-percents dao-item__percents">
                  <span className="dao-item__value">{item.percent}</span>
                </div>
              </div>
            </li>
          ))}
          <li className="dao-item dao-item__vote">
            <GradientButton className="dao-item__btn">Vote</GradientButton>
          </li>
        </ul>
        <div className="astr-content">
          <img src="/assets/images/astr.png" alt="ast" />
        </div>
      </div>
    </div>
  );
}
